import { render } from "./NcrmPreferredViewTabs.vue?vue&type=template&id=3f086f48&scoped=true"
import script from "./NcrmPreferredViewTabs.vue?vue&type=script&lang=js"
export * from "./NcrmPreferredViewTabs.vue?vue&type=script&lang=js"

import "./NcrmPreferredViewTabs.vue?vue&type=style&index=0&id=3f086f48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f086f48"]])

export default __exports__